var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userType === _vm.USER_TYPE.OWNER)?_vm._t("owner"):(_vm.userType === _vm.USER_TYPE.REGULAR)?_vm._t("regular"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }